import Vue from 'vue'
import axios from 'axios'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import VueLocalStorage from 'vue-localstorage'
import { FontAwesomeIcon } from './icons'
import { i18n } from './i18n'
import VueDOMPurifyHTML from 'vue-dompurify-html'

Vue.use(VueDOMPurifyHTML);

import VueLodash from 'vue-lodash'
import Datetime from 'vue-datetime';

import './assets/scss/style.scss';
import 'bootstrap/dist/js/bootstrap';

//Import Froala Editor 
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg';

Vue.use(VueFroala);

import Layout from './components/layouts/Layout.vue'
import AuthLayout from './components/layouts/AuthLayout.vue'
import AdminLayout from './components/layouts/admin/AdminLayout.vue'
import AdminAuthLayout from './components/layouts/admin/AdminAuthLayout.vue'
import TranslationKeyInput from './components/misc/TranslationKeyInput.vue'

Vue.component('layout', Layout);
Vue.component('auth-layout', AuthLayout);
Vue.component('admin-layout', AdminLayout);
Vue.component('admin-auth-layout', AdminAuthLayout);
Vue.component('translation-key-input', TranslationKeyInput);

Vue.prototype.$http = axios;

Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(VueLocalStorage);
Vue.use(Datetime);
Vue.use(VueLodash);

Vue.prototype.$cookies = VueCookies;
Vue.component('icon', FontAwesomeIcon);

sync(store, router);

axios.interceptors.request.use(
    (config) => {
        let token = VueCookies.get('access_token') || null;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

const app = new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
}).$mount('#app');